import { getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useState } from "react";
import toast from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import useDebounce from "hooks/useDebounce";
import { Button, Input } from "styled";
import { TD, TH } from "styled/table";
import axios from "apis/axios";
import Add from "components/twc-issues/Add";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import Edit from "components/twc-issues/Edit";
import { FaEdit, FaTrash } from "react-icons/fa";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";

const TWCIssues = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 1000);
  const [page, setPage] = useState(1);

  const { data: twcIssues, isLoading } = useQuery([`/getTWCIssues`, debouncedValue && debouncedValue], () =>
    getAllData(`twcRoutes/getAllTwcIssues`, { searchQuery: debouncedValue })
  );

  return (
    <div>
      {showAddmodel && <Add handleClick={() => setShowAddmodel(false)} />}
      <div className="m-10">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
          <Button
            className="!px-8 disabled:bg-gray-400"
            bgPrimary
            onClick={() => setShowAddmodel(true)}
            // disabled={!checkPermission(currentUser)}
          >
            Add
          </Button>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Issue Name</TH>
                      <TH scope="col">Price</TH>
                      <TH scope="col">Action</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {twcIssues?.data &&
                      twcIssues?.data.map((item, index) => (
                        <ViewList
                          data={item}
                          key={item?._id}
                          index={index}
                          //   formik={formik}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {twcIssues?.totalPage > 1 && (
        <div className="container mx-auto flex justify-center items-center gap-2 py-5">
          <Button
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            disabled={page === 1}
            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
            primary
          >
            <div className="flex gap-1 items-center">
              <IoMdArrowBack />
              Prev Page
            </div>
          </Button>
          <span className="text-gray-600 px-4">{page}</span>

          <Button
            onClick={() =>
              setPage((p) => Math.min(p + 1, twcIssues?.pageInfo?.total))
            }
            disabled={page === twcIssues?.pageInfo?.total}
            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
            primary
          >
            <div className="flex gap-1 items-center">
              Next Page
              <IoMdArrowForward />
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};

export default TWCIssues;

const ViewList = ({ data, index, formik }) => {
  const [showEditModel, setShowEditModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const queryClient = useQueryClient();
  const activateDeactivateHandler = () => {
    axios({
      url: "twcRoutes/deleteTwcIssue",
      method: "DELETE",
      headers: {
        Authoriztaion: `Bearer ${currentUser.token}`,
      },
      data: {
        twcIssueId: data._id,
        status: !data.status,
      },
      baseURL: `${process.env.REACT_APP_API_URL}`,
    })
      .then((res) => {
        toast.success("Successfully saved");
        queryClient.invalidateQueries("/getTWCIssues");
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  return (
    <Fragment>
      <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{index + 1}</TD>
        <TD>{data.issueName}</TD>
        <TD>{data.price}</TD>
        {checkPermission([permissions.manage_twc_issues], currentUser) &&<TD>
          <div className="">
            <button
              onClick={() => setShowEditModel(true)}
              className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
            >
              <FaEdit />
            </button>
            <button
              onClick={activateDeactivateHandler}
              className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
            >
              <FaTrash />
            </button>
          </div>
        </TD>}
      </tr>
      {showEditModel && (
        <Edit data={data} handleClick={() => setShowEditModel(false)} />
      )}
    </Fragment>
  );
};
